import { render, staticRenderFns } from "./ExtActProcessNodePermissionList.vue?vue&type=template&id=9b050e56&scoped=true&"
import script from "./ExtActProcessNodePermissionList.vue?vue&type=script&lang=js&"
export * from "./ExtActProcessNodePermissionList.vue?vue&type=script&lang=js&"
import style0 from "./ExtActProcessNodePermissionList.vue?vue&type=style&index=0&id=9b050e56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b050e56",
  null
  
)

export default component.exports